<template>
  <div>
    <h1 class="page-header">{{ $t('firstCyclePaid.firstCyclePaid') }}</h1>
    <ts-card>
      <ts-card-wrapper>
        <form class="form-horizontal">
          <div class="ts-flex">
            <div class="ts-flex">
              <label class="col-sm-4 control-label">{{ $t('workSchedule.year') }}</label>
              <div>
                <ts-date-picker-input v-model="cycle_year" format="YYYY"></ts-date-picker-input>
              </div>
            </div>
            <div class="ts-flex">
              <label class="col-sm-4 control-label">{{ $t('workSchedule.month') }}</label>
              <div>
                <ts-date-picker-input v-model="cycle_month" format="MM"></ts-date-picker-input>
              </div>
            </div>
            <ts-button class="ml-2" color="danger" outline @click.prevent="remove" :waiting="deleting">{{
              $t('button.remove')
            }}</ts-button>
            <div class="ts-flex-grow"></div>
            <ts-input style="width: 300px" v-model="search" :placeholder="$t('search')" />
          </div>
        </form>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record, index }">
          <td>{{ record.employee.employee_name_en }}</td>
          <td>{{ record.employee.employee_name_kh }}</td>
          <td>{{ record.position_name }}</td>
          <td class="text-center">{{ record.cycle_month }}</td>
          <td class="text-center">{{ record.cycle_year }}</td>
          <td class="text-center">{{ record.salary }}</td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'first-cycle-paid',
  data() {
    return {
      loading: false,
      deleting: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('hr/firstCyclePaid', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.hr.firstCyclePaid.search
      },
      set(newValue) {
        this.$store.commit('hr/firstCyclePaid/SET_SEARCH', newValue)
        this.$store.commit('hr/firstCyclePaid/RESET_CURRENT_PAGE')
      }
    },
    cycle_year: {
      get() {
        return this.$store.state.hr.firstCyclePaid.cycle_year
      },
      set(val) {
        this.$store.commit('hr/firstCyclePaid/SET_CYCLE_YEAR', val)
      }
    },
    cycle_month: {
      get() {
        return this.$store.state.hr.firstCyclePaid.cycle_month
      },
      set(val) {
        this.$store.commit('hr/firstCyclePaid/SET_CYCLE_MONTH', val)
      }
    },
    columns() {
      return [
        {
          name: this.$t('firstCyclePaid.employeeNameEn')
        },
        {
          name: this.$t('firstCyclePaid.employeeNameKh')
        },
        {
          name: this.$t('firstCyclePaid.position')
        },
        {
          name: this.$t('firstCyclePaid.cycleMonth'),
          style: 'text-align:center; width: 7%;'
        },
        {
          name: this.$t('firstCyclePaid.cycleYear'),
          style: 'text-align:center; width: 7%;'
        },
        {
          name: this.$t('firstCyclePaid.salary'),
          style: 'text-align:center; width: 7%;'
        }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('hr/firstCyclePaid/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    async remove() {
      if (await this.$confirmModal.danger(this.$t('are_you_sure_to_delete'))) {
        this.deleting = true
        this.$store
          .dispatch('hr/firstCyclePaid/destroy', { cycle_year: this.cycle_year, cycle_month: this.cycle_month })
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            this.deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            this.deleting = false
          })
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500),
    cycle_year: function(date) {
      this.fetchData()
    },
    cycle_month: function(date) {
      this.fetchData()
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('hr/firstCyclePaid/RESET_STATE')
    next()
  }
}
</script>
